module.exports = __webpack_public_path__ + "static/img/IL.bf3de5de.svg";